<script lang="ts">
  import InboxWorkflowPreconfigurationBox from "@kontextwerk/control-web-frame/shared/modules/inbox-workflow-preconfiguration-box"
  import {
      notifyInboxWorkflowPreconfigurationApplyResult,
      resolveInboxWorkflowPreconfigurationTargets,
  } from "@kontextwerk/control-web-frame/shared/logic/inbox-workflow"
  import Input from "@kontextwerk/web-sdk/ui/forms/Input.svelte"

  import type { PrintSelectionPreconfigurationMode } from "../../_shared/_logic/print-selection-preconfiguration"
  import type { PrintSelectionPreviewRow } from "../../../../../../_shared/_logic/print-selection-preview"
  import {
    withKeepPreconfigurationOption,
    type PreconfigurationChoice,
  } from "../../../../../../../../../../../../_shared/_logic/preconfiguration-keep"

  let {
    rows,
    selectedIds,
    disabled = false,
    onApply,
  }: {
    rows: PrintSelectionPreviewRow[]
    selectedIds: string[]
    disabled?: boolean
    onApply: (
      rows: PrintSelectionPreviewRow[],
      mode: PreconfigurationChoice<PrintSelectionPreconfigurationMode>,
    ) => void
  } = $props()

  // "Nur notwendige" reproduces the initial print recommendation of every row.
  let printMode = $state<PreconfigurationChoice<PrintSelectionPreconfigurationMode>>("necessary")

  const targetResolution = $derived(
    resolveInboxWorkflowPreconfigurationTargets({
      rows,
      selectedIds,
      getId: (row) => row.letter_delivery_batch_item_id,
      isEligible: (row) => row.printable,
    }),
  )

  const apply = () => {
    onApply(targetResolution.targetRows, printMode)
    notifyInboxWorkflowPreconfigurationApplyResult({
      total: targetResolution.targetRows.length + targetResolution.skippedRows.length,
      applied: targetResolution.targetRows.length,
      skipped: targetResolution.skippedRows.length,
      reason: targetResolution.skippedRows.length
        ? "Nicht druckbare Terminbriefe wurden ausgelassen."
        : undefined,
    })
  }
</script>

<InboxWorkflowPreconfigurationBox
  selectedCount={selectedIds.length}
  targetCount={targetResolution.targetRows.length}
  {disabled}
  emptyLabel="Keine druckbaren Terminbriefe in der aktuellen Auswahl"
  onApply={apply}
>
  <div class="preconfiguration-grid">
    <Input
      type="select"
      label="Drucken"
      bind:value={printMode}
      brightBackground={false}
      surfaceTone="dark"
      options={withKeepPreconfigurationOption([
        { value: "no", name: "Nein" },
        { value: "yes", name: "Ja" },
        { value: "necessary", name: "Nur notwendige" },
      ])}
    />
  </div>
</InboxWorkflowPreconfigurationBox>

<style>
  .preconfiguration-grid {
    padding-top: 1rem;
    display: grid;
    gap: 1rem;
    grid-template-columns: minmax(12rem, 1fr);
    max-width: 32rem;
  }
</style>
